import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

type props = {
  isOpen: boolean;
  reportBtnLabel: string;
  onClose?: () => void;
  onReportClick?: () => void;
};

const OptionsModalComponent: React.FC<props> = ({ isOpen, reportBtnLabel, onClose, onReportClick }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => onClose?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  const modalContent = (
    <div className="options-modal-overlay" onClick={handleOverlayClick}>
      <div className="options-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="options-modal-container">
          <div className="options-modal-title">{t("what-action-do-you-want-to-take")}</div>

          <button type="button" className="options-modal-button" onClick={onReportClick}>
            {reportBtnLabel}
          </button>

          <button type="button" className="options-modal-cancel-button" onClick={onClose}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default OptionsModalComponent;
